export default "__VITE_ASSET__CfhK1vKf__"